import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { FirmAgreementActions } from "@/features/firms/components/firm-agreement-actions"
import { FirmAgreementCurrent } from "@/features/firms/components/firm-agreement-current"
import { FirmAgreementEmptyState } from "@/features/firms/components/firm-agreement-empty-state"
import { FirmAgreementHistory } from "@/features/firms/components/firm-agreement-history"
import { agreementQueries } from "@/queries/agreements"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/"
)({
  staticData: { attention: "firm.agreement" },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      agreementQueries.forFirm(params.firmId)
    ),
  component: FirmAgreementPage,
})

function FirmAgreementPage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="AR agreement"
        actions={<FirmAgreementActions firmId={firmId} />}
      />

      <div className="mx-auto flex w-full max-w-5xl flex-col gap-10">
        <FirmAgreementCurrent firmId={firmId} />
        <FirmAgreementHistory firmId={firmId} />
      </div>

      <FirmAgreementEmptyState firmId={firmId} />
    </>
  )
}
